/**
 * OverallItemScoff
 * 
 * @Author: Focci
 * @Date: 2024-11-07 09:11:21
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-07 09:11:21
 */

import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import ErrorIcon from '@mui/icons-material/Error'
import clsx from 'clsx'
import Switch from '@comp/form/Switch'
import { useEffect, useMemo, useState } from 'react'
import StyledPopover from '@comp/StyledPopover'

function OverallItemScoffHead({ stowable, title, open, ...props }) {
  return (
    <div 
      className={clsx([
        'p-2 text-f.7 flex items-center gap-0.5',
        stowable && 'cursor-pointer select-none'
      ])}
      {...props}
    >
      {stowable && <PlayArrowIcon className={clsx(['size-2', open && 'rotate-90'])} />}
      {title}
    </div>
  )
}

export default function OverallItemScoff({
  stowable = true,
  expanding = false,
  title,
  children
}) {
  const [open, setOpen] = useState(expanding)
  const headProps = useMemo(() => (stowable
    ? { onClick: () => setOpen((prev) => !prev) }
    : null
  ), [stowable])

  useEffect(() => { setOpen(expanding) }, [expanding])

  return (
    <>
      <OverallItemScoffHead 
        stowable={stowable} 
        title={title}
        open={open}
        {...headProps}
      />
      {open && (
        <div className="px-3 py-1">
          {children}
        </div>
      )}
    </>
  )
}

export function OverallItemSwitch({ label, checked, description, badge, ...props }) {
  return (
    <div className="flex items-center gap-2">
      <Switch small checked={checked} {...props} />
      <div className="flex-auto text-f.6 md:text-f.7">
        {label}
        {badge && (
          <span className="bg-red-500 text-white rounded-sm text-f.6 h-3 px-0.5 inline-flex items-center ml-1">
            {badge}
          </span>
        )}
      </div>
      {description && (
        <StyledPopover trigger={<ErrorIcon className="size-3 text-[#7b7b7b]" />}>
          <div className="bg-black text-white text-f.6 max-w-72 p-2">
            {description}
          </div>
        </StyledPopover>
      )}
    </div>
  )
}
